module.exports = __webpack_public_path__ + "img/02-1.b17f5162.png";